import React from 'react';
import Slider from 'react-slick';
import { jsx, css } from '@emotion/core';

import { primary_l50 } from '../../../shared/lib/colors';

import './BottomSlider.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const BottomSlider = ({
  loading = false,
  slides,
  primaryColor,
  uiVariantBannerCarousel,
}) => {
  const dotsStyle = css`
    .slick-dots {
      display: flex !important;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: -40px;

      li {
        display: block;
        margin: 0 5px;
        height: ${uiVariantBannerCarousel === '1' ? '8px' : '10px'};
        width: ${uiVariantBannerCarousel === '1' ? '8px' : '10px'};

        &.slick-active {
          height: ${uiVariantBannerCarousel === '1' ? '12px' : '10px'};
          width: ${uiVariantBannerCarousel === '1' ? '12px' : '10px'};

          .dot {
            height: ${uiVariantBannerCarousel === '1' ? '12px' : '10px'};
            width: ${uiVariantBannerCarousel === '1' ? '12px' : '10px'};
            background-color: ${primaryColor};
          }
        }

        .dot {
          padding: 0;
          height: ${uiVariantBannerCarousel === '1' ? '8px' : '10px'};
          width: ${uiVariantBannerCarousel === '1' ? '8px' : '10px'};
          background-color: ${uiVariantBannerCarousel !== '1'
            ? 'transparent'
            : '#fff'};
          border: ${uiVariantBannerCarousel !== '1'
            ? `1px solid ${primaryColor}`
            : 'none'};
          border-radius: ${uiVariantBannerCarousel !== '2' ? '50%' : 0};

          &:before {
            content: none;
          }

          &:focus,
          &:hover,
          &.active {
            background-color: ${uiVariantBannerCarousel !== '1'
              ? primaryColor
              : primary_l50(primaryColor)};
          }
        }
      }
    }
  `;

  const settings = {
    arrows: false,
    dots: true,
    customPaging: function(i) {
      return <button className="dot">{/* {i + 1} */}</button>;
    },
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: uiVariantBannerCarousel !== '3' ? 2 : 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 1 } },
      //{ breakpoint: 768, settings: { slidesToShow: 2 } },
      // { breakpoint: 567, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className={`bottom-slider variant-${uiVariantBannerCarousel}`}>
      <Slider {...settings} css={dotsStyle}>
        {slides.map(slide => {
          return (
            <div key={slide.id} className="banner">
              <a href={slide.link}>
                <ImageDispatcher
                  src={slide.imgUrl}
                  alt={slide.seoName}
                  className="img-fluid"
                  style={{
                    borderRadius: uiVariantBannerCarousel === '1' ? '12px' : 0,
                  }}
                />
              </a>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default BottomSlider;
